module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/send-dd25c2bcacc1b5f8ae12fcf5268295dc.svg";